import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import { fireSacUpdateEvent, writeStorage } from '../sacStorage';

// tslint:disable-next-line:max-line-length
// https://stackoverflow.com/questions/53154564/how-to-get-all-possible-values-of-a-union-type-to-an-array-or-the-other-way-aro
function stringTuple() {
  for (var _len = arguments.length, data = new Array(_len), _key = 0; _key < _len; _key++) {
    data[_key] = arguments[_key];
  }

  return data;
}

var storageKeysV2 = stringTuple('originCustomerId', 'selectedAddressId', 'selectedServiceId', 'businessPartnerId', 'customerCode', 'premiseId', 'contractAccountId', 'addresses', 'properties', 'services');

var updateStorage = function updateStorage(state, dontFireEvent) {
  var storageObj = _Object$keys(state).filter(function (key) {
    return storageKeysV2.includes(key);
  }).reduce(function (storage, key) {
    storage[key] = state[key];
    return storage;
  }, {});

  writeStorage(storageObj);

  if (!dontFireEvent) {
    fireSacUpdateEvent();
  }
};

export { updateStorage };